import React, { useEffect } from 'react';
import { View, Text, StyleSheet, Image } from '@react-18-pdf/renderer';

const styles = StyleSheet.create({
  image: {
    padding: 10,
    width: 60
  },
  title: {
    fontSize: 12,
    textAlign: 'center',
  },
  subTitle: {
    fontSize: 12,
    textAlign: 'center',
    marginTop: 10,
  },
  info: {
    fontSize: 8,
    textAlign: 'center',
  },
  details: {
    fontSize: 8,
    textAlign: 'left',
  },
  header: {
    position: 'absolute',
    top: 20,
    left: 20,
    right: 25,
  },
});

const Header = (props) => {

  return (
    <View style={styles.header}>
      <View style={{ flexDirection: "row", width: "100%" }}>
        <View style={{ alignItems: "flex-start", marginLeft: 5, width: "100%", textAlign: "center" }} >
          <Text style={styles.title}>{props.title}</Text>
          {(props.info != null ? <Text style={styles.info}>{props.info}</Text> : null)}
        </View>
      </View>
    </View>
  )

};

export { Header };
